import {
    Box,
    Grid,
} from '@mantine/core';

import {ProfileWidget} from './dashboard/ProfileWidget.tsx';
import {RegistrarsWidget} from './dashboard/RegistrarsWidget.tsx';
import {ReactNode} from "react";
import {DomainNamesWidget} from "./dashboard/DomainNamesWidget.tsx";
import {TopLevelDomainsWidget} from "./dashboard/TopLevelDomainsWidget.tsx";
import {useVerifiedPermissions} from "@flexinet/auth-components";

export const PortalDashboard = () => {

    const {allowedActions} = useVerifiedPermissions()

    const columns = {
        leftColumn: [],
        rightColumn: []
    } as { leftColumn: ReactNode[], rightColumn: ReactNode[] }

    if (allowedActions.includes('ViewDashboard')) {
        columns.leftColumn.push(<ProfileWidget/>)
    }
    if (allowedActions.includes('ListDomainNames')) {
        columns.leftColumn.push(<DomainNamesWidget/>)
    }


    if (allowedActions.includes('ListRegistrars')) {
        columns.rightColumn.push(<RegistrarsWidget/>)
    }

    if (allowedActions.includes('ListTopLevelDomains')) {
        columns.rightColumn.push(<TopLevelDomainsWidget/>)
    }


    return (
        <Grid mx={'10%'}>

            <Grid.Col span={{
                xl: 6,
                lg: 6,
                md: 12,
                sm: 12,
                xs: 12,
            }}>
                {columns.leftColumn.map((item, index) => <Box key={index}>{item}</Box>)}
            </Grid.Col>

            <Grid.Col span={{
                xl: 6,
                lg: 6,
                md: 12,
                sm: 12,
                xs: 12,
            }}>
                {columns.rightColumn.map((item, index) => <Box key={index}>{item}</Box>)}
            </Grid.Col>

        </Grid>
    );
};
